// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"378":"0d21059b","453":"6d3403a0","793":"657d84ab"}[chunkId] + ".chunk.js";
};